import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import LoadingSpinner from '../layout/LoadingSpinner';
import { trackEvent } from '../../segment';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

const ReportsIframe = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const classId = queryParams.get('classId') || '';
    const subjectId = queryParams.get('schoolSubjectId') || '';
    const division = queryParams.get('division') || '';
    const selectedSubject = queryParams.get('subjectId') || '';
    const selectedSubjectName = queryParams.get('subjectName') || '';
    const ayId = queryParams.get('ayId') || '';
    const isElga = queryParams.get('isElga') || ''
    const usid = queryParams.get('usid')
    const [url, setUrl] = useState('');

    const [isLoading, setIsLoading] = useState(true);
    const [showIframe, setShowIframe] = useState(false);

    const data = useSelector(
        (state: RootState) => state.SchoolInfo.data
    );

    useEffect(() => {
        const isATOrAC = Number(data?.academicyearid) >= 10 && !!data?.school?.teachingPlatforms?.some(
            (platform: any) => platform.code === 'ACDMA' || platform.code === 'CDAIB' || platform.code === 'ACTTE'
        );

        const newUrl = `${process.env.REACT_APP_REPORTS_URL}chapterList?source=Active Teach&classId=${classId}&schoolSubjectId=${subjectId}&subjectId=${selectedSubject}&ayId=${ayId}&division=${division}&subjectName=${selectedSubjectName}&isElga=${isElga}&usid=${usid}&IsATOrAC=${isATOrAC}`;

        setUrl(newUrl);
    }, [data]);
    

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowIframe(true);
        }, 500);

        return () => clearTimeout(timer); // cleanup if the component unmounts early
    }, []);

    const handleLoad = () => {
        setIsLoading(false);
    };

    useEffect(() => {
        const listener = (e:any) => {
            if (e.data?.type === "GO_BACK") {
                window.parent.location.href = `/assignments-reports`;
            }
            else if(e.data?.type === 'event'){
                trackEvent(e.data.eventName, e.data.eventData)
            }
        };
        window.addEventListener("message", listener);
        return () => window.removeEventListener("message", listener);
      }, []);

    return (
        <div>
            {isLoading && (
                <div className="absolute inset-0 flex items-center justify-center bg-white z-10">
                    <LoadingSpinner />
                </div>
            )}
            {showIframe && (
                <iframe
                    id="reports-iframe"
                    className="content-iframe w-full h-screen transition transform duration-500 ease-in-out px-8 bg-[#ECF0F4]"
                    src={url}
                    title={`ReportsIframe`}
                    onLoad={handleLoad}
                    style={{ opacity: isLoading ? 0 : 1 }}
                />
            )}
        </div>
    );
};

export default ReportsIframe;
